<template>
  <div
    :class="[error?.statusCode === 404
               ? 'error-not-found'
               : 'error',
             'd-flex flex-column mt-0 pa-0']"
  >
    <v-btn
      color="primary"
      class="back"
      dark
      :size="mobile ? 'large' : 'x-large'"
      rounded="xl"
      variant="elevated"
      @click="handleError()"
    >
      Go Back
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { clearError, useError } from 'nuxt/app'
import { ref } from 'vue'
import { useDisplay } from 'vuetify'

const handleError = () => clearError({ redirect: '/' })
const { mobile } = useDisplay()
const error = ref(useError())
</script>

<style scoped>
.error-not-found {
    background-image: url("public/404-alt-2.jpg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #f7f7f7;
    min-height: 90vh;
    text-align: center;
    color: black;
}

.error {
    height: 100vh;
    background-image: url("public/error.jpg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #f7f7f7;
    text-align: center;
    color: black;
}

.back {
    position: fixed;
    bottom: 20%;
    left: 45%;
}

@media only screen and (max-width: 700px) {
    .back {
        left: 35%;
    }
}
</style>
